import React, { createContext, useContext } from 'react';
import { useCourse } from '@hooks';

/**
 * Course Context for current course data
 * Supports lazy loading for large courses (40+ modules)
 */
const CourseContext = createContext(null);

export function CourseProvider({ courseId, children }) {
  const { course, loading, error, loadSectionDetails } = useCourse(courseId);

  const value = {
    course,
    loading,
    error,
    courseId,
    loadSectionDetails, // Method to load section details on demand
  };

  return <CourseContext.Provider value={value}>{children}</CourseContext.Provider>;
}

export function useCourseContext() {
  const context = useContext(CourseContext);
  if (!context) {
    throw new Error('useCourseContext must be used within CourseProvider');
  }
  return context;
}
